// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_SP_footer__GyDrE","content":"Footer_SP_content__310XJ"};